import React, { useContext } from 'react';
import { Grid2 } from '@riac/design-system';
import { cn, TextLink, Typography } from '@up-riac/bespoke-ui';
import { GlobalDataContext } from 'src/lib/GlobalDataContext';

export const UtilityHeader = ({ ...props }) => {
  const { activeAuctions } = useContext(GlobalDataContext);
  const liveAuction = activeAuctions.find((auction) => auction.active);
  return (
    <Grid2
      {...props}
      innerContainerClassName='h-[38px] dark bg-surface-dark w-full grid grid-cols-[1fr_auto_1fr] items-center gap-x-4'
      className={cn(
        'py-0',
        (!liveAuction) && 'hidden lg:grid'
      )}
    >
      {liveAuction
        && <div className='min-w-0 col-start-2'>
          <Typography weight='extrabold' size='sm' className='text-text-contrast flex gap-2 items-baseline min-w-0' id='utility-live-auction-notice'>
            <div className='bg-[#22C55E] size-[10px] rounded-full' id='utility-live-auction-notice-indicator'>
              <div className='bg-[#22C55E] size-[10px] rounded-full animate-ping'/>
            </div>
            <span className='truncate'>{liveAuction.Title}: </span>
            <TextLink
              color='text'
              underlineStyle='inverse'
              className='p-0 underline-offset-[25%] hover:underline decoration-2 min-w-max font-extrabold'
              to='/live' id={'utility-live-auction-notice-button'}
            >
              Bid now
            </TextLink>
          </Typography>
        </div>
      }
      <div className='col-start-3 justify-self-end flex-row items-center h-[22px] hidden md:flex'>
        <div className='pointer-events-auto'>
          <TextLink color='text' id='utility-faq-link' to='/faq' className='block p-0 px-2'>
            <Typography size='sm' weight='semibold'>FAQ</Typography>
          </TextLink>
        </div>
        <div className='w-px h-[15px] bg-text-contrast'/>
        <div className='pointer-events-auto'>
          <TextLink color='text' id='utility-contact-link' to='/contact' className='block p-0 px-2'>
            <Typography size='sm' weight='semibold'>Contact</Typography>
          </TextLink>
        </div>
      </div>
    </Grid2>
  );
};
